"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocalStorage = void 0;
var LogUtils = require("../Utils/LogUtils");
var LocalStorage = /** @class */ (function () {
    function LocalStorage() {
        this._debug = false;
        // constructor
    }
    Object.defineProperty(LocalStorage.prototype, "hasUserData", {
        get: function () {
            return localStorage.length > 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LocalStorage.prototype, "debug", {
        set: function (pValue) {
            this._debug = pValue;
        },
        enumerable: false,
        configurable: true
    });
    //#region Bool Storage
    /**
     * Stores a Bool
     * @param pID The ID to store the bool
     * @param pValue The stored bool value
     */
    LocalStorage.prototype.storeBool = function (pID, pValue) {
        var value = pValue ? "true" : "false";
        this.log("STORING BOOL: %s at value: %s", pID, value);
        localStorage.setItem(pID, value);
    };
    /**
     * Reads a Bool
     * @param pID The ID to read the bool
     * @param pDefault The default value of the returned bool
     * @param returns Returns the stored bool if it can find it. If not, will return pDefault
     */
    LocalStorage.prototype.readBool = function (pID, pDefault) {
        if (pDefault === void 0) { pDefault = false; }
        var item = localStorage.getItem(pID);
        if (item !== null) {
            var boolValue = item === "true" ? true : false;
            return boolValue;
        }
        return pDefault;
    };
    //#endregion
    //#region Number Storage
    /**
     * Stores a Number
     * @param pID The ID to store the number
     * @param pValue The stored number value
     */
    LocalStorage.prototype.storeNumber = function (pID, pValue) {
        var value = pValue.toString();
        this.log("STORING NUMBER: %s at value: %s", pID, value);
        localStorage.setItem(pID, value);
    };
    /**
     * Reads a Number
     * @param pID The ID to read the number
     * @param pDefault The default value of the returned number
     * @param returns Returns the stored number if it can find it. If not, will return pDefault
     */
    LocalStorage.prototype.readNumber = function (pID, pDefault) {
        if (pDefault === void 0) { pDefault = 0; }
        var item = localStorage.getItem(pID);
        if (item !== null) {
            var numberValue = +item;
            return numberValue;
        }
        return pDefault;
    };
    //#endregion
    //#region String Storage
    /**
     * Stores a String
     * @param pID The ID to store the string
     * @param pValue The stored string value
     */
    LocalStorage.prototype.storeString = function (pID, pValue) {
        this.log("STORING STRING: %s at value: %s", pID, pValue);
        localStorage.setItem(pID, pValue);
    };
    /**
     * Reads a String
     * @param pID The ID to read the string
     * @param pDefault The default value of the returned string
     * @param returns Returns the stored string if it can find it. If not, will return pDefault
     */
    LocalStorage.prototype.readString = function (pID, pDefault) {
        if (pDefault === void 0) { pDefault = ""; }
        var item = localStorage.getItem(pID);
        if (item !== null) {
            return item;
        }
        return pDefault;
    };
    //#endregion
    /**
     * Deletes an item
     * @param pID The ID of the item to delete
     * @param returns Returns a bool based on if the value was removed or not
     */
    LocalStorage.prototype.deleteItem = function (pID) {
        var item = localStorage.getItem(pID);
        if (item !== null) {
            localStorage.removeItem(pID);
            return true;
        }
        this.log("Trying to delete %s when it doesn't exist!", pID);
        return false;
    };
    /**
     * Prints all values stored in local storage
     */
    LocalStorage.prototype.printAll = function () {
        for (var i = 0; i < localStorage.length; ++i) {
            var key = localStorage.key(i);
            if (key !== null) {
                var value = localStorage.getItem(key);
                if (value !== null) {
                    LogUtils.log("Key: %s | Value: %s", { className: "LocalStorage", color: "blue" }, key, value);
                }
            }
        }
    };
    /**
     * Deletes all data saved in local storage
     */
    LocalStorage.prototype.deleteAllData = function () {
        localStorage.clear();
    };
    LocalStorage.prototype.log = function (pText) {
        var pParams = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            pParams[_i - 1] = arguments[_i];
        }
        if (this._debug) {
            LogUtils.log.apply(LogUtils, __spreadArrays([pText, { className: "LocalStorageManager", color: "orange" }], pParams));
        }
    };
    return LocalStorage;
}());
exports.LocalStorage = LocalStorage;
//# sourceMappingURL=LocalStorage.js.map